export const tierLimits = [105000, 123000, 164000];
export const coupleTierLimits = [210000, 246000, 328000];

export const age65Rebates = ['24.118%', '16.079%', '8.038%', '0%'];
export const age69Rebates = ['28.139%', '20.098%', '12.058%', '0%'];
export const age70Rebates = ['32.158%', '24.118%', '16.079%', '0%'];

//export const age65Rebates = ['24.608%', '16.405%', '8.202%', '0%'];
//export const age69Rebates = ['28.710%', '20.507%', '12.303%', '0%'];
//export const age70Rebates = ['32.812%', '24.608%', '16.405%', '0%'];

// export const age65Rebates = ['24.288%', '16.192%', '8.095%', '0%'];
// export const age69Rebates = ['28.337%', '20.240%', '12.143%', '0%'];
// export const age70Rebates = ['32.385%', '24.288%', '16.192%', '0%'];

export const REBATE_VERSION = {
  new: {
    age65: ['24.118%', '16.079%', '8.038%', '0%'],
    age69: ['28.139%', '20.098%', '12.058%', '0%'],
    age70: ['32.158%', '24.118%', '16.079%', '0%'],
  },
  old: {
    age65: ['24.608%', '16.405%', '8.202%', '0%'],
    age69: ['28.710%', '20.507%', '12.303%', '0%'],
    age70: ['32.812%', '24.608%', '16.405%', '0%'],
  },
};
